import axios from "~/axios";

const login = async(baseUrl, username, password) => {
    let ret = (await axios.post(`${baseUrl}/authenticate`, {username, password})).data;

    return ret;
};

export default login;